import { render, staticRenderFns } from "./QuickTipsReviewRetireMergeIdDetails.vue?vue&type=template&id=a71310ec&scoped=true&"
import script from "./QuickTipsReviewRetireMergeIdDetails.vue?vue&type=script&lang=js&"
export * from "./QuickTipsReviewRetireMergeIdDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71310ec",
  null
  
)

export default component.exports